<template>
    <div class="tree-item">
        <span class="title">
            <span>{{ title }}</span>
        </span>
        <i-Spin v-if="spinShow"></i-Spin>
        <div class="legend" v-if="showLengend">
            <div
                class="legend-line"
                v-for="(value, key) in legendData"
                :key="key"
            >
                <div
                    :style="{ background: lengendColor(key) }"
                    class="lengend-color"
                ></div>
                <span class="lengend-text">{{ lengendText(key) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: { root: Array, node: Object, data: Object },
    computed: {
        // 标题
        title() {
            return this.data.title;
        },
        showLengend() {
            if (
                this.data.checked &&
                this.data.planId &&
                this.data.plan &&
                this.data.plan.colors &&
                this.data.plan.showMap
            ) {
                return true;
            } else {
                return false;
            }
        },
        legendData() {
            return this.data.plan.ranges.length - 1;
        },
        spinShow() {
            return !!(this.data.plan && this.data.plan.loading);
        },
    },
    methods: {
        lengendColor(key) {
            return this.data.plan.colors[key];
        },
        lengendText(key) {
            if (this.data.plan.ranges.length > 0) {
                const first = this.data.plan.ranges[key];
                const second = this.data.plan.ranges[key + 1];
                return first + ' - ' + second;
            }
        },
    },
};
</script>
